<template>
  <div>
    <div class="card-body">
        <b-table show-empty :items="$route.params.users" :fields="fields" v-if="$route.params.users">
      </b-table>
    </div>
  </div>
</template>
<script>

export default {
    name: 'users',
    computed: {
      fields() { 
        return [
          { key: 'fullName', label: this.$i18n.t('datatables.naam'), sortable: true },
        ]
      }
    }
}
</script>